(
	function () {
		/**
		 * News container
		 *
		 * @type {Element}
		 */
		const newsContainer = document.querySelector( '.section-blog__articles' );

		if ( !newsContainer ) {
			return;
		}

		newsContainer.scrollTo( 0, 0 );

		const navigationElement = document.createElement( 'div' );
		navigationElement.classList.add( 'news-carousel-navigation' );

		const prevBtn = document.createElement( 'button' );
		'slick-prev slick-arrow slick-disabled'.split( ' ' ).forEach( ( className ) => prevBtn.classList.add( className ) );
		prevBtn.setAttribute( 'aria-label', 'Previous' );
		prevBtn.setAttribute( 'aria-hidden', 'true' );
		prevBtn.setAttribute( 'type', 'button' );
		prevBtn.innerText = 'Prev news';

		const nextBtn = document.createElement( 'button' );
		'slick-next slick-arrow'.split( ' ' ).forEach( ( className ) => nextBtn.classList.add( className ) );
		nextBtn.setAttribute( 'aria-label', 'Next' );
		nextBtn.setAttribute( 'aria-hidden', 'true' );
		nextBtn.setAttribute( 'type', 'button' );
		nextBtn.innerText = 'Next news';

		navigationElement.insertAdjacentElement( 'beforeend', prevBtn );
		navigationElement.insertAdjacentElement( 'beforeend', nextBtn );

		newsContainer.insertAdjacentElement( 'afterend', navigationElement );

		prevBtn.addEventListener( 'click', () => {
			newsContainer.scrollBy( {
				left: newsContainer.offsetWidth * - 1,
				behavior: "smooth"
			} );
		} );

		nextBtn.addEventListener( 'click', () => {
			newsContainer.scrollBy( {
				left: newsContainer.offsetWidth,
				behavior: "smooth"
			} );
		} );

		newsContainer.addEventListener( 'scroll', ( event ) => {
			const {scrollLeft, offsetWidth, scrollWidth} = newsContainer;

			if ( 0 === scrollLeft ) {
				prevBtn.classList.add( 'slick-disabled' );
				nextBtn.classList.remove( 'slick-disabled' );
			} else if ( scrollLeft + offsetWidth >= scrollWidth - 40 ) {
				prevBtn.classList.remove( 'slick-disabled' );
				nextBtn.classList.add( 'slick-disabled' );
			} else {
				prevBtn.classList.remove( 'slick-disabled' );
				nextBtn.classList.remove( 'slick-disabled' );
			}
		}, {
			passive: true
		} );
	}()
);
